import * as React from "react";
import "./FacesheetIncome.scss";
import { getFormattedName } from "../../services/stringService";
import {
    getCountableAndNonCountablePersons,
    getTotalCountableAndExcludedIncome,
    getTotalMonthlyIncomeForMember,
} from "../../services/magiServices";

export const FacesheetIncome = ({ interview, interviewHousehold, magiHousehold, patient }) => {
    const getMember = id => {
        if (id === patient.personId) {
            return `${getFormattedName(
                patient.firstName,
                patient.middleInitial,
                patient.lastName,
                patient.suffix
            )} (Patient)`;
        } else {
            const member = interviewHousehold.find(m => m.personId === id);
            return `${getFormattedName(member.firstName, member.middleInitial, member.lastName, member.suffix)} ( ${
                member.relationshipToPatient
            } )`;
        }
    };

    const { countable, nonCountable } = getCountableAndNonCountablePersons(interviewHousehold, magiHousehold);

    const personsWithGroupedIncomes = getTotalCountableAndExcludedIncome(interview, countable, magiHousehold);

    return (
        <div className="facesheet-income">
            <div className="household-group">
                <h3>Countable</h3>
                <div className="household-members">
                    {personsWithGroupedIncomes.map((person, i) => {
                        return (
                            <div className="facesheet-income__card" key={i}>
                                <p className="facesheet-income__line-item-name h4">{getMember(person.personId)}</p>
                                <p className="facesheet-income__line-item">
                                    <span className="h5">Allowable: </span>${person.totalAllowable?.toFixed(2)}
                                </p>
                                <p className="facesheet-income__line-item">
                                    <span className="h5">Excluded: </span>${person.totalExcluded?.toFixed(2)}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>

            {nonCountable && nonCountable?.length > 0 && (
                <div className="household-group">
                    <h3>Non Countable</h3>
                    <div className="household-members">
                        {nonCountable.map((person, i) => {
                            const totalIncome = getTotalMonthlyIncomeForMember(person.personId, interview);
                            return (
                                <div className="facesheet-income__card" key={i}>
                                    <p className="facesheet-income__line-item-name h4">{getMember(person.personId)}</p>
                                    <p className="facesheet-income__line-item">
                                        <span className="h5">Excluded: </span>${totalIncome?.toFixed(2)}
                                    </p>
                                </div>
                            );
                        })}
                        <span />
                    </div>
                </div>
            )}
        </div>
    );
};
